var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading105_container"},[_c('div',{attrs:{"id":"load"}},[_c('div',[_vm._v("你")]),_c('div',[_vm._v("好")]),_c('div',[_vm._v("Kun")]),_c('div',[_vm._v("Kun")]),_c('div',[_vm._v(".")]),_c('div',[_vm._v(".")]),_c('div',[_vm._v(".")])])])
}]

export { render, staticRenderFns }